import './LangButton.css';
import React from 'react';
// import axios from 'axios';
// import { Avatar } from 'antd';
import { chosen_lang, show_header, redir } from '../RecoilState';
import { useRecoilState } from 'recoil';

const LangButton = ({ details }) => {

  
  const [c_lang, setCLang] = useRecoilState(chosen_lang);
  const [showheader, setShowheader] = useRecoilState(show_header);
  const [redirect, setRedirect] = useRecoilState(redir);
  

  const updateLang = () => {
    // console.log(details.code);
    setShowheader(true);
    setRedirect("login");
    setCLang({
      language: details.language,
      code : details.code,
      flag : details.flag,
    });
  }
  // console.log(c_lang);

  return (
    <>
      <button className="lang-button" onClick={updateLang}>
        <img src={require(`../assets/${details.flag}`)} width="45" />
        <h2 className="text-bold">{details.language}</h2>
      </button>
    </>
  )
}

export default LangButton